<p-float-label>
  <p-inputgroup>
    @if (!layoutService?.isScreenSmaller(ScreenBreakpoint.MD)) {
      <p-inputgroup-addon>
        <p-button
          [icon]="defaultIcon.Rewind"
          styleClass="vertical-align-middle"
          (click)="moveBackWeeks()"
          pTooltip="Prior Week Range"
          />
        </p-inputgroup-addon>
      }
      <p-inputgroup-addon>
        <p-button
          [icon]="defaultIcon.Previous"
          styleClass="vertical-align-middle"
          (click)="moveBackWeek()"
          pTooltip="Prior Week"
          />
        </p-inputgroup-addon>
        <p-datepicker
          #calendar
          [showIcon]="true"
          [(ngModel)]="controlValue"
          selectionMode="range"
          inputId="weekSelectionId"
          [showClear]="false"
          appendTo="body"
          (onblur)="onChange()"
          (onSelect)="onChange()"
          (onClear)="onChange()"
          (onShow)="onShow()"
          (onClose)="onClose()"
          [showWeek]="showWeekNumber"
          [dateFormat]="format"
          class="flex grow"
          [required]="required"
          [touchUI]="layoutService.mobile$ | async"
          [size]="size"
          />
          <!--
          inputStyleClass="date-Format"
          -->
          <p-inputgroup-addon>
            <p-button
              [icon]="defaultIcon.Today"
              styleClass="vertical-align-middle"
              (click)="moveToToday()"
              pTooltip="Today"
              />
            </p-inputgroup-addon>
            <p-inputgroup-addon>
              <p-button
                [icon]="defaultIcon.Next"
                styleClass="vertical-align-middle"
                (click)="moveForwardWeek()"
                pTooltip="Next Week"
                />
              </p-inputgroup-addon>
              @if (!layoutService?.isScreenSmaller(ScreenBreakpoint.MD)) {
                <p-inputgroup-addon>
                  <p-button
                    [icon]="defaultIcon.FastForward"
                    styleClass="vertical-align-middle"
                    (click)="moveForwardWeeks()"
                    pTooltip="Next Week Range"
                    />
                  </p-inputgroup-addon>
                }
              </p-inputgroup>
              <label for="weekSelectionId">{{ label ?? 'Date' }}</label>
            </p-float-label>
